/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from '@angular/core';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class WebSocketService {

  constructor(

  ) { }

  public connect(url: string): Rx.Subject<any> {
    return this.create(url)
  }

  private create(url: string): Rx.Subject<any> {
	
    const ws = new WebSocket(url);

    const observable = Rx.Observable.create(
      (obs: Rx.Observer<MessageEvent>) => {
        ws.onmessage = obs.next.bind(obs);
        ws.onerror = obs.error.bind(obs);
        ws.onclose = obs.complete.bind(obs);
        return ws.close.bind(ws);
      }
    );

    const observer = {
      next: (data: Object) => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
        }
      }
    };
    
    return Rx.Subject.create(observer, observable);
  }

}
